import React from "react";
import DotsComponent from "../DotsComponent";
import './Finance.css'

const FinanceLiabilityTable = (props) => {
  return props.data.map((val) => {
    return (
      <>
      {/* <DotsComponent/> */}
      <div className="current-table">
        <h3>CURRENT LIABILITY</h3>
        <table className="table_">
          <tr className="table_background">
            <th style={{color:"#fff",marginTop:'5px'}}>Account Payable</th>
            <td style={{color:"#fff"}}>{val.currentLibilities}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Credit Card Dept</th>
            <td>{val.accountPayable}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Bank Operating Credit</th>
            <td>{val.creditcardDept}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Accrued Expenses</th>
            <td>{val.bankoperatingCredit}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Taxes Payable</th>
            <td>{val.AccuredExpences}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Current Liability</th>
            <td>{val.taxesPayable}</td>
          </tr>
        </table>
      </div>
      </>
    );
  });
};

export default FinanceLiabilityTable;
